import { QUERY_KEYS, SERVER_ROUTES } from "@constants/api.routes";
import type { ProfileUpdateResponse, UpdateProfilePayload } from "../../types";
import { api } from "@config/axios/axios.config";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { HTTP_STATUS } from "@constants/http.status.code";
import { showNotification } from "@libs/notistack/notificationStack";
import { SNACKBAR_SEVERITY } from "@constants/notificationStack";
import { updateUserProfile } from "@store/slices/userSlice";

export const useUpdateProfile = () => {
	const queryClient = useQueryClient();
	const dispatch = useDispatch();

	return useMutation({
		mutationFn: async (data: UpdateProfilePayload) => {
			const response = await api.patch<ProfileUpdateResponse>(SERVER_ROUTES.USER.PROFILE_UPDATE, data);
			return response.data;
		},
		onSuccess: (response: ProfileUpdateResponse, variables: UpdateProfilePayload) => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER.GET_PROFILE] });
			dispatch(
				updateUserProfile({
					firstName: variables.firstName,
					lastName: variables.lastName,
					phoneNumber: variables.phoneNumber,
					emailAddress: variables.emailAddress,
				}),
			);

			if (response?.statusCode === HTTP_STATUS.OK || response?.statusCode === HTTP_STATUS.CREATED) {
				if (response?.message) {
					showNotification({
						message: response?.message,
						severity: SNACKBAR_SEVERITY.SUCCESS,
					});
				}
			}
		},
	});
};
